import {
  Box,
  Group,
  Modal as MantineModal,
  ModalProps as MantineModalProps,
  Stack,
} from '@mantine/core';
import React from 'react';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';

export interface IModalProps extends MantineModalProps {
  title: string;
  actions?: React.ReactNode[];
  opened: boolean;
  onClose: () => void;
}

const DefaultModalProps: Partial<IModalProps> = {
  size: 'lg',
};

/** @registry Standard Mantine Modal wrapper with a built-in Close button plus caller-supplied action buttons; use instead of raw Mantine Modal for consistent footer actions. */
export const Modal = React.memo<IModalProps>(
  ({ title, children, actions, opened, onClose, ...props }) => {
    return (
      <MantineModal
        {...DefaultModalProps}
        opened={opened}
        onClose={onClose}
        title={title}
        {...props}
      >
        <Stack gap="lg">
          <Box>{children}</Box>
          <Group justify="flex-end">
            <SecondaryButton size="sm" onClick={onClose}>
              Close
            </SecondaryButton>
            {actions?.map((action, index) => (
              <React.Fragment key={index}>{action}</React.Fragment>
            ))}
          </Group>
        </Stack>
      </MantineModal>
    );
  },
);
